// extracted by mini-css-extract-plugin
module.exports = {"extra_info":"styles_extra_info__2Ncix"};